import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {durationFormatter} from "../../../../_metronic/_helpers";
import {useSelector} from "react-redux";
import Grow from "@material-ui/core/Grow";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {loadParameter} from "../../../redux_slices/contextSlice";

//components:

const PlansAndPayment = ({plans, plansError, isLoadingPlans}) => {
    const {t} = useTranslation();
    const {limit_indexing = "", total_count = ""} = plans;

    const entryPack = useSelector(state => loadParameter(state, "entryPack"));

    const formattedIndexed = durationFormatter(total_count);
    const exceededTime = () => {
        const limitInSeconds = limit_indexing * 60 * 60;
        const excess = total_count - limitInSeconds;

        return excess > 0 ? durationFormatter(Math.abs(excess)) : false;
    };

    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-light justify-content-between align-items-center">
                    <div className="card-title">{t("ADMINPANEL.PLANS.TITLE")}</div>
                    <div className="card-title">0{t("ADMINPANEL.PLANS.COST")}</div>
                </div>
                <div className="card-body position-relative">
                    <div className="d-flex justify-content-between align-items-start font-size-h6 mb-5">
                        <div className="font-size-h5">{t("ADMINPANEL.PLANS.ENTRY_PACK")}</div>
                        <button className="btn btn-primary" disabled>
                            {t("ADMINPANEL.PLANS.CHANGE_PLAN")}
                        </button>
                    </div>
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center mb-5">
                            <div
                                className="d-flex p-1 bg-light justify-content-center align-items-center mr-2"
                                style={{width: "fit-content"}}
                            >
                                <i className="fas fa-check text-success" />
                            </div>
                            <span>{entryPack}</span>
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100"
                        style={{
                            opacity: plansError && plansError.text ? 1 : 0,
                            zIndex: plansError && plansError.text ? 1 : -1,
                            transition: "0.4s ease all",
                        }}
                    >
                        <div className={`alert alert-${plansError.type || "info"} font-size-h5 font-weight-bold`}>
                            <WarningRoundedIcon color="inherit" className="mr-5" />
                            {plansError.text}
                        </div>
                    </div>
                    <div
                        className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100"
                        style={{
                            opacity: isLoadingPlans ? 1 : 0,
                            zIndex: isLoadingPlans ? 1 : -1,
                            transition: "0.4s ease all",
                        }}
                    >
                        <CircularProgress />
                    </div>
                </div>
            </div>
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-light justify-content-between align-items-center">
                    <div className="card-title">{t("ADMINPANEL.PLANS.INDEXING")}</div>
                    <div className="card-title">
                        {limit_indexing || "0"}h {t("ADMINPANEL.PLANS.INCLUDED")}
                    </div>
                </div>
                <div className="card-body">
                    <div className="d-flex justify-content-between font-size-h5 py-8">
                        <div className="col-6">{t("ADMINPANEL.PLANS.HOURS_INDEXED")}</div>
                        <div className="d-flex align-items-end flex-column col-6">
                            <p className="text-primary mb-3">{formattedIndexed}</p>
                            {exceededTime() ? (
                                <Grow
                                    in={true}
                                    timeout={{
                                        appear: 500,
                                        enter: 500,
                                    }}
                                >
                                    <span className="font-size-sm text-warning">{`(${t(
                                        "ADMINPANEL.PLANS.EXCEEDED"
                                    )} ${exceededTime()})`}</span>
                                </Grow>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

PlansAndPayment.propTypes = {
    plans: PropTypes.object,
};

export default PlansAndPayment;
